// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"2162bfe6","513":"239ed241","703":"6335121e","787":"ba3963f0"}[chunkId] + ".chunk.js";
};